import { useQuery } from "@tanstack/react-query";
import { getWinners } from "services/apiwinners";

export function useWinners() {
  const {
    isLoading,
    data: winners,
    error,
  } = useQuery({
    queryKey: ["winners"],
    queryFn: getWinners,
  });

  return { isLoading, winners, error };
}
